import { Component } from "@angular/core";
import { FormBuilder, FormGroup, FormArray, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { PlacePickerComponent } from "src/app/place-picker/place-picker.component";
import { ApiService } from "src/app/shared/services/api.service";
import { ToastrMsgService } from "src/app/shared/services/shared-services/toastr.service";


@Component({
  selector: 'app-add-branch',
  templateUrl: './add-branch.component.html',
  styleUrl: './add-branch.component.css'
})
export class AddBranchComponent {

  userEForm!: FormGroup;
  organizationId: any;
  
   availableStates: any[] = [];
  availableCities: any[] = [];
  selectedFile: File | null = null;
  searchKeyword = "";
  branchList:any
  constructor(
    private formBuilder: FormBuilder,
    private readonly apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private readonly toastrMsgService: ToastrMsgService,private dialog: MatDialog
  ) {



  }


  ngOnInit() {
   
    this.route.params.subscribe((params) => {
      this.organizationId = params['id'];
    });
    if (this.organizationId) {
    }

    this.userEForm = this.formBuilder.group({
      additionalBranch: this.formBuilder.array([this.createBranchGroup()])
    });
    this.availableStates[0] = [];
    this.availableCities[0] = [];

  }

  // Getter for easy access
  get additionalBranch() {
    return this.userEForm.get('additionalBranch') as FormArray;
  }

  // Create one contact group
  createBranchGroup(): FormGroup {
    return this.formBuilder.group({
      org_id: [this.organizationId, Validators.required],
      lat: ['', Validators.required],
      long: ['', Validators.required,],
      city: ['', Validators.required,],
      state: ['', Validators.required],
      country: ['', Validators.required],
      postal_code: ['', Validators.required],
      branch_name: ['', Validators.required],
      primary_contact_name: ["", Validators.required],
      primary_contact_email: ["", [Validators.required, Validators.email]],
      primary_contact_phone: ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      registration_number: [""],
      gst_number: ["", [Validators.pattern('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$')]],
      pan_number: ["", [Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]{1}$')]],
      domain: ["", Validators.required],
      address_line_1: ["", Validators.required],
      address_line_2: ["", Validators.required],
    });
  }

  // Add new contact
  addBranch() {
    this.additionalBranch.push(this.createBranchGroup());
    // Also prepare arrays for new index
    const index = this.additionalBranch.length - 1;
    this.availableStates[index] = [];
    this.availableCities[index] = [];
  }

  // Remove contact at index
  removeBranch(index: number) {
    if (this.additionalBranch.length > 1) {
      this.additionalBranch.removeAt(index);
    }
    this.availableStates.splice(index, 1);
    this.availableCities.splice(index, 1);
  }


  onSubmit(): void {
      console.log(this.userEForm.value.additionalBranch)

    const formattedBranches = this.userEForm.value.additionalBranch.map((branch: { domain: any[]; }) => ({
      ...branch,
      domain: Array.isArray(branch.domain) ? branch.domain.join(', ') : branch.domain
    }));
      this.apiService.saveOrganizationBranch(formattedBranches).subscribe({
        next: (res) => {
          this.toastrMsgService.success('Branch added successfully');
         this.router.navigate(['/home/organization-branch-list', this.organizationId]);

        },
        error: (err) => {
          this.toastrMsgService.error(err.error.errorMessage);
        },
        complete: () => console.log("Observable complete"),
      });
  }


  onCountryBChange(index: number) {
    const branch = this.additionalBranch.at(index);
    const selectedCountry = branch.get('country')?.value;

    // const countryObj = this.countries.find(c => c.name === selectedCountry);
    // this.availableStates[index] = countryObj ? countryObj.states : [];
    // this.availableCities[index] = [];
      this.apiService.getstates().subscribe({
      next: (res) => {
        console.log(res);
        this.availableStates[index] = res ? res : []
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log("Observable complete"),
    });

    // Reset dependent controls
    branch.patchValue({ state: '', city: '' });
  }

  onStateBChange(index: number) {
    const branch = this.additionalBranch.at(index);
    const selectedCountry = branch.get('country')?.value;
    const selectedState = branch.get('state')?.value;
        this.apiService.getdistricts(selectedState).subscribe({
      next: (res) => {
        console.log(res);
        this.availableCities[index] = res ? res : [];
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log("Observable complete"),
    });


    // Reset city control
    branch.patchValue({ city: '' });
  }

    openPicker(index: number, branch: any) {
        const dialogRef = this.dialog.open(PlacePickerComponent, {
          width: '600px',
        });
      
        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            console.log('Selected Coordinates:', result);
            branch.patchValue({
              lat: result.lat,
              long: result.lng
            });
          }
        });
      }

}
